<script>
    import {fly, fade} from 'svelte/transition';
    import bodymovin from 'lottie-web';
    import AnimationText from './animation_text.svelte';
    import {animationPlayedOn, playAnimation} from '../../store';

    let background = false;
    let animationContainer;
    let navAnimation = 'start';
    // const hide_animation=false;
    let animationBackgroundColor='white';
    let animation;
    let animationtext=false;
    $: {
        if (animationContainer) {
            animation = bodymovin.loadAnimation({
                container: animationContainer,
                renderer: 'svg',
                loop: false,
                autoplay: false,
                path: 'animations/desktop_starting_animation.json',
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMax slice',
                },
            });
            animation.addEventListener('complete', () => {
                navAnimation = 'none';
                setTimeout(() => {
                    animationPlayedOn.update((n) => new Date());
                }, 500);
            });
            animation.addEventListener('enterFrame', (ev) => {
                if (ev.currentTime > 210) animationtext = true;
            });
        }
    }
    $: {
        if (animation) {
            setTimeout(() => startBodymovinAnimation(), 2000);
            setTimeout(() => (animationBackgroundColor = 'blue'), 14000);
        }
    }
    $: if (!playAnimation) {
        animationtext = false;
    }

    /**
     * @func
     */
    function startBodymovinAnimation() {
        animation.play();
        setTimeout(() => background = true, 3000);
    }
</script>


{#if playAnimation}
    <div class="animation-container" out:fly="{{y: -2000, x: 0, duration: 2000}}" bind:this={animationContainer}></div>
    {#if background}
        <div class="animation-background {animationBackgroundColor}" out:fade="{{duration: 1500}}"></div>
    {/if}
    {#if animationtext}
        <AnimationText  />
    {/if}
{/if}

<style>
    .animation-container {
        z-index: 11;
        position: absolute;
        height: 100%;
        width: 100%;
    }
    .animation-background {
        height: 100vh;
        width: 100%;
        position: absolute;
        z-index: 10;
    }
    .animation-background.white {
        background-color: white;
    }
    .animation-background.blue {
        background-color: #175a9e;
    }
    .sli {
        padding: 0.5vw;
        border-radius: 1vw;
    }
    .sli:hover {
        background: #e2f2ff;
        border-radius: 1vw;
    }
    .light_animate {
        position: absolute;
        width: 100%;
        margin-top: 0;
        animation-name: light;
        animation-duration: 0.5s;
        animation-delay: 0s;
        animation-iteration-count: 1;
        overflow: hidden;
        z-index: -1;
    }
    @keyframes light {
        0% {
            margin-top: -44vw;
        }
        100% {
            margin-top: 0;
        }
    }
    .img-wrraper {
        width: 17.5vw;
        margin-left: 0;
        transform: scaleX(-1);
    }
    .lighting-animation {
        animation: light_left 1.8s 0s 1;
    }
    @keyframes light_left {
        0% {
            margin-left: -19vw;
            margin-top: -19vh;
        }
        100% {
            margin-left: 0vw;
            margin-top: 0;
        }
    }
    .img-wrraper:nth-child(2) {
        width: 17.5vw;
        transform: scaleX(1);
    }
    .lighting-animation:nth-child(2) {
        animation: light_right 1.8s 0s 1;
    }
    @keyframes light_right {
        0% {
            margin-right: -19vw;
            margin-top: -19vh;
        }
        100% {
            margin-right: 0vw;
            margin-top: 0;
        }
    }
    .slider::-webkit-scrollbar {
        display: none;
    }
    .slider {
        scroll-behavior: smooth;
    }
    .slider-img {
        width: 6.5vw;
        height: 6.5vw;
        border-radius: 1vw;
        overflow: hidden;
        margin: auto;
    }
    .data-part {
        width: 12vw;
        margin: auto;
        text-align: center;
        font-size: 1vw !important;
    }
    .arrowpostion {
        width: fit-content;
        background-color: black;
        border-radius: 50px;
        padding: 5px;
        cursor: pointer;
        font-size: 0.8vw;
    }
    .logo-wrraper {
        width: 10vw;
        margin-left: auto;
        cursor: pointer;
    }
    .head_text2 {
        font-size: 1.1vw;
        background: linear-gradient(90deg, #005c97 0%, #363795 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .btn2 {
        border: 0;
        margin: 0 1vw 0 1vw;

        border-radius: 50vw;
        font-size: 0.8vw;
    }
    .btn2:nth-child(1) {
        background-color: #3c74c0;
        color: white;
        padding: 0.2vw 1.5vw 0.2vw 1.5vw;
    }
    .btn2:nth-child(2) {
        background-color: white;
        color: #3c74c0;
        border: 1px #3c74c0 solid;
        padding: 0.2vw 3vw 0.2vw 3vw;
    }
    .btn2:nth-child(1):hover {
        background-color: #f7e05f;
        color: #3c74c0;
        transition-duration: 0.3s;
    }
    .btn2:nth-child(2):hover {
        background-color: #f7e05f;
        border: 1px solid #f7e05f;
        color: #3c74c0;
        transition-duration: 0.3s;
    }
    .circle {
        background-color: #7cc1ff;
        height: 1vw;
        width: 1vw;
        border-radius: 1vw;
        margin-top: 0.5vw;
    }
    .btn-mbl-sidebar {
        border: 0;
        margin: 60vw 0vw 0 21vw;
        padding: 1vw 3vw 1vw 3vw;
        border-radius: 50vw;
        font-size: 3.271vw;
        background-color: #3c74c0;
        color: white;
    }
    .menu-back-style {
        background-color: #eeeff196;
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 100vw;
        z-index: 3;
        top: 0vw;
    }
    .logo-img {
        width: 28vw;
    }
    .main-div {
        justify-content: space-between;
        display: flex;
        align-items: center;
        padding: 3vw;
        background-color: white;
        position: fixed;
        width: 100vw;
        height: 18.692vw;
        z-index: 1;
        box-shadow: inset 0px 10px 8px -12px #ccc,
            inset 0px -10px 8px -12px #ccc;
    }
    .menu-section {
        position: fixed;
        height: 100vh;
        width: 67.056vw;
        background-color: #ffffff;
        z-index: 3;
        right: 0vw;
        cursor: pointer;
        left: 100vw;
        top: 0vw;
    }
    .head-mbl {
        justify-content: end;
        display: flex;
        margin-top: 3vw;
        cursor: pointer;
        position: relative;
    }
    .h-clr {
        color: #3c74c0;
        margin-right: 6vw;
        font-size: 3.738vw;
        margin-top: 1.5vw;
    }
    .hr-css {
        width: 59.112vw;
        margin-top: 6.776vw;
        margin-left: 5.972vw;
    }
    .hr {
        color: #c4c4c4;
        opacity: 1;
        height: 2px;
        width: 90%;
    }
    .list {
        margin-top: 10vw;
    }
    .head-logo {
        margin-right: 5vw;
        width: 28.654vw;
        margin-right: -0.5vw;
        margin-top: 27vw;
    }
    .head-mbl:hover {
        background-color: #f7e05f;
    }
    .logo-sidebar {
        width: 40vw;
        margin-left: 17vw;
        margin-top: 6vw;
    }
    .mobile {
        padding: 0;
    }
    .head-text-mbl {
        width: 76.168vw;
        margin-top: 13.551vw;
        margin-left: 11.916vw;
    }
    .name-text {
        font-weight: bold;
    }
    .text {
        position: absolute;
        top: 23vw;
    }
    .head-text2-mbl {
        width: 56.776vw;
        margin-top: 5.607vw;
        margin-left: 21.495vw;
    }
    .btn1-mbl {
        padding: 1vw 8vw 1vw 8vw;
        border-radius: 50vw;
        font-size: 2.336vw;
        background-color: white;
        color: #3c74c0;
        border: 1px #3c74c0 solid;
    }
    .btn-css {
        margin-top: 14.953vw;
        margin-left: 13.513vw;
        text-align: center;
    }
    .btn2-mbl {
        border: 0;
        margin-top: 1.869vw;
        padding: 1vw 4vw 1vw 4vw;
        border-radius: 50vw;
        font-size: 2.336vw;
        background-color: #3c74c0;
        color: white;
    }
    .back-img {
        overflow: hidden;
        display: flex;
        justify-content: space-between;
    }
    .back-img-mbl-left {
        width: 26.654vw;
        margin-left: -3.5vw;
        margin-top: 32vw;
        filter: brightness(2.5);
        transform: scaleX(-1);
    }
    .back-img-mbl-right {
        width: 26.654vw;
        margin-right: -3.5vw;
        margin-top: 32vw;
        filter: brightness(2.5);
    }
    .slider-mbl {
        scroll-behavior: smooth;
        display: flex;
        justify-content: space-between;
        overflow: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        margin: 20vw 0 15vw 0;
        padding: 5vw 0;
        background-color: rgba(245, 251, 255, 1);
    }
    .slider-mbl::-webkit-scrollbar {
        display: none;
    }
    .desktop {
        display: block;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .mobile {
            display: block;
        }
        .light_animate {
            display: none !important;
        }
        .img-warraper-mbl {
            width: 19.159vw;
            height: 19.159vw;
            margin-left: 8vw;
        }
        .sli-mbl {
            border-radius: 1vw;
            margin-left: 3.346vw;
        }
        .data-part-mbl {
            width: 34.168vw;
            margin: auto;
            text-align: center;
            font-size: 3.271vw !important;
            margin-top: 4.673vw;
        }
    }
</style>
